import { COMPANY_PREFIX, COMPANY_TYPE } from '../constants/company';
import { isMetisStudent } from '../utils/common';
import { getCurCompany } from '../utils/company';
var _productId = isMetisStudent ? '21000036' : '21000037';
var origin = 'https://login.feixiangxingqiu.com';
var feixiangLaoshiOrigin = 'https://login.feixianglaoshi.com';
var company = getCurCompany();
var prefix = COMPANY_PREFIX[company];
var defaultRedirect = 'https://laoshi.feixiangxingqiu.com';
switch (company) {
  case COMPANY_TYPE.HSMSF:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.com/hsmsf';
    break;
  case COMPANY_TYPE.PGQJYWYH:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.com/pgqjywyh';
    break;
  case COMPANY_TYPE.FEIXIANG:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.com';
    break;
  case COMPANY_TYPE.JIANGUAN:
    defaultRedirect = 'https://jianguan.feixiangxingqiu.com';
    break;
  case COMPANY_TYPE.FLYING:
    defaultRedirect = 'https://shouji.feixiangxingqiu.com';
    break;
  case COMPANY_TYPE.WX_MOBILE:
    defaultRedirect = 'https://ke.feixiangxingqiu.com/suicai/#/logistics-list';
    break;
}
var feixiangxingqiu = {
  HTTP_BASE_URL: 'https://mapi.feixiangxingqiu.com',
  AVATAR_PREFIX: 'https://metis-online.fbcontent.cn/metis-account/metis-avatar/',
  lectioHome: 'https://ke.feixiangxingqiu.com',
  resetPsdURL: "".concat(origin).concat(prefix, "/#/embed/reset-password"),
  defaultRedirect: defaultRedirect,
  defaultRedirectStudent: 'https://xuesheng.feixiangxingqiu.com',
  loginURL: "".concat(origin).concat(prefix, "/#/login"),
  designationLoginURL: "".concat(origin).concat(prefix, "/#/designation-login"),
  designationStudentLoginURL: "".concat(origin).concat(prefix, "/#/designation-student-login"),
  openLoginURL: "".concat(origin).concat(prefix, "/#/open-login"),
  chooseURL: "".concat(origin).concat(prefix, "/#/embed/choose"),
  perfectURL: "".concat(origin).concat(prefix, "/#/embed/info"),
  noPermissionUrl: "".concat(origin).concat(prefix, "/#/embed/403"),
  WX_SCAN_REDIRECT_location: 'https://mapi.feixiangxingqiu.com',
  WX_SCAN_REDIRECT_URL: 'https://mapi.feixiangxingqiu.com/metis-weixin/api/ws/wxc39e354c2762b109/oauth-forward',
  WX_SCAN_APPID: 'wxc39e354c2762b109',
  WX_SCAN_REDIRECT_BACK_URL: "".concat(origin).concat(prefix, "/#/embed/personal-data"),
  teacherTemplate: 'https://metis-online.fbcontent.cn/metis-lectio/kBH613TBliaaKZMIFcty.xlsx',
  loginDomain: '.feixiangxingqiu.com',
  _productId: _productId
};
var feixianglaoshi = {
  HTTP_BASE_URL: 'https://mapi.feixianglaoshi.com',
  AVATAR_PREFIX: 'https://metis-online.fbcontent.cn/metis-account/metis-avatar/',
  lectioHome: 'https://ke.feixianglaoshi.com',
  resetPsdURL: "".concat(feixiangLaoshiOrigin, "/#/embed/reset-password"),
  defaultRedirect: 'https://pro.feixianglaoshi.com',
  defaultRedirectStudent: 'https://pro.feixianglaoshi.com',
  loginURL: "".concat(feixiangLaoshiOrigin, "/#/login"),
  designationLoginURL: "".concat(feixiangLaoshiOrigin, "/#/designation-login"),
  designationStudentLoginURL: "".concat(feixiangLaoshiOrigin, "/#/designation-student-login"),
  openLoginURL: "".concat(feixiangLaoshiOrigin, "/#/open-login"),
  chooseURL: "".concat(feixiangLaoshiOrigin, "/#/embed/choose"),
  perfectURL: "".concat(feixiangLaoshiOrigin, "/#/embed/info"),
  noPermissionUrl: "".concat(feixiangLaoshiOrigin, "/#/embed/403"),
  WX_SCAN_REDIRECT_location: 'https://mapi.feixianglaoshi.com',
  WX_SCAN_REDIRECT_URL: 'https://mapi.feixianglaoshi.com/metis-weixin/api/ws/wxc39e354c2762b109/oauth-forward',
  WX_SCAN_APPID: 'wxc39e354c2762b109',
  WX_SCAN_REDIRECT_BACK_URL: "".concat(feixiangLaoshiOrigin, "/#/embed/personal-data"),
  teacherTemplate: 'https://metis-online.fbcontent.cn/metis-lectio/kBH613TBliaaKZMIFcty.xlsx',
  loginDomain: '.feixianglaoshi.com',
  _productId: _productId
};
var origin100 = 'https://login.top100school.com';
var company100 = getCurCompany();
var prefix100 = COMPANY_PREFIX[company100];
var top100 = {
  HTTP_BASE_URL: 'https://mapi.feixiangxingqiu.com',
  AVATAR_PREFIX: 'https://metis-online.fbcontent.cn/metis-account/metis-avatar/',
  lectioHome: 'https://mapi.top100school.com/lectio/#/home',
  resetPsdURL: "".concat(origin100).concat(prefix100, "/#/embed/reset-password"),
  defaultRedirect: 'https://mapi.top100school.com/lectio/#/home',
  defaultRedirectStudent: 'https://xuesheng.feixiangxingqiu.com',
  loginURL: "".concat(origin100).concat(prefix100, "/#/login"),
  designationLoginURL: "".concat(origin100).concat(prefix100, "/#/designation-login"),
  designationStudentLoginURL: "".concat(origin100).concat(prefix100, "/#/designation-student-login"),
  openLoginURL: "".concat(origin100).concat(prefix100, "/#/open-login"),
  chooseURL: "".concat(origin100).concat(prefix100, "/#/embed/choose"),
  perfectURL: "".concat(origin100).concat(prefix100, "/#/embed/info"),
  noPermissionUrl: "".concat(origin100).concat(prefix100, "/#/embed/403"),
  WX_SCAN_REDIRECT_location: 'https://mapi.feixiangxingqiu.com',
  WX_SCAN_REDIRECT_URL: 'https://mapi.feixiangxingqiu.com/metis-weixin/api/ws/wxc39e354c2762b109/oauth-forward',
  WX_SCAN_APPID: 'wxc39e354c2762b109',
  WX_SCAN_REDIRECT_BACK_URL: "".concat(origin100).concat(prefix100, "/#/embed/personal-data"),
  teacherTemplate: 'https://metis-online.fbcontent.cn/metis-lectio/kBH613TBliaaKZMIFcty.xlsx',
  loginDomain: '.top100school.com',
  _productId: _productId
};
var config = {
  feixiangxingqiu: feixiangxingqiu,
  feixianglaoshi: feixianglaoshi,
  top100: top100
};
export default config;